import { Pet } from './Pet';
import Phaser from 'phaser';

export class LaserPet extends Pet {
  constructor(scene: Phaser.Scene, earth: any, angle: number) {
    super(scene, earth, angle);
    this.damage = 18;
    this.attackSpeed = 2.2;
    this.range = 120;
    // Visual: hình tròn nhỏ xanh lá
    this.add(scene.add.circle(0, 0, 10, 0x00ff90));
  }
  override attack(): void {
    if (!this.target) return;
    const laser = this.scene.add.graphics();
    laser.lineStyle(3, 0x00ff90);
    laser.beginPath();
    laser.moveTo(this.x, this.y);
    laser.lineTo(this.target.x, this.target.y);
    laser.strokePath();
    (this.target as any).takeDamage(this.damage);
    this.scene.time.delayedCall(80, () => laser.destroy());
    // Hiệu ứng nổ nhỏ
    const fx = this.scene.add.circle(this.target.x, this.target.y, 8, 0x00ff90, 0.5);
    this.scene.time.delayedCall(60, () => fx.destroy());
  }
} 